import { InbondStorageAuditPendingRoutesModel, InbondStorageRoutesModel } from "@shared/models/routes/inbond-storage-routes.model";
import { CompletedRoutesModel, PendingRoutesModel, RedeliveryRoutesModel } from "../models/routes/redelivery-routes.model";
import { DetentionMultiProRoutesModel } from "../models/routes/detention-multi-pro-routes.model";

export enum AppRoutes {
  LANDING_PAGE = 'landing-page',
  DATA_ENTRY_PAGE = 'data-entry-page',
  NOT_AUTHORIZED_PAGE = 'not-authorized',
  STORAGE_ACCESSORIAL_CHARGES = 'accessorial-literal',
  LIST = 'list',
  DETENTION_WITH_POWER = 'detention-with-power',
  DETENTION_WITH_POWER_MULTI_PRO = 'detention-with-power-multi-pro',
  DETAIL_PAGE = 'detail-page',
  REDELIVERY = 'redelivery',
  INBOND_STORAGE = 'inbond-storage',
}

const RedeliveryPendingRoutes: PendingRoutesModel = {
  main: 'pending'
};

const correctionsBillDetailsRoutes: CompletedRoutesModel = {
  main: 'completed'
};

export const RedeliveryRoutes: RedeliveryRoutesModel = {
  main: 'redelivery',
  deny: 'deny',
  completed: correctionsBillDetailsRoutes,
  pending: RedeliveryPendingRoutes
};

const InbondStorageAuditPendingRoutes: InbondStorageAuditPendingRoutesModel = {
  main: 'audit-pending'
};

const InbondStorageOperationsPendingRoutes: PendingRoutesModel = {
  main: 'operations-pending'
};

const InbondStorageCompletedRoutes: CompletedRoutesModel = {
  main: 'completed'
};

export const InbondStorageRoutes: InbondStorageRoutesModel = {
  main: 'inbond-storage',
  deny: 'deny',
  completed: InbondStorageCompletedRoutes,
  auditPending: InbondStorageAuditPendingRoutes,
  operationsPending: InbondStorageOperationsPendingRoutes
};

export const DetentionMultiProRoutes: DetentionMultiProRoutesModel = {
  main: 'detention-with-power-multi-pro',
  audit: { main: 'audit' },
  completed: { main: 'completed' },
  legacy: 'list'
};

export const AcAutomationRoutesLabels = {
  storate: 'Storage',
  detention: 'Detention With Power',
  redelivery: 'Redelivery',
  inbondStorage: 'In-Bond Storage'
};
